[
    {
        "TemplateName": "Brazil"
    },
    {
        "TemplateName": "Canada"
    },
    {
        "TemplateName": "Japan"
    },
    {
        "TemplateName": "Iraq"
    },
    {
        "TemplateName": "Japan"
    },
    {
        "TemplateName": "Lithuania"
    },
    {
        "TemplateName": "France"
    },
    {
        "TemplateName": "Malaysia"
    },
    {
        "TemplateName": "Russia"
    },
    {
        "TemplateName": "China"
    }
]
